import { LocationResults } from "./locationResults";
import { LocationFacets } from "./locationFacets";
import { resolveApiUrl } from "@grindex-common/helpers/apiUrlResolver";

import FindALocationDropDown from "./FindALocationDropDown.class";
import FindALocationFieldValidator from "./findALocationFieldValidator.class";
import FindALocationBlockDom from "./xyl.views.findALocationBlock.dom";

function init($views) {
	const $module = $views[0];

	let brandName = null;
	let skipValidation = true;

	const URL_STATESFORBRAND = "api/location/GetStatesForBrand";
	const URL_MARKETSFORBRAND = "api/location/GetMarketsForBrand";
	const URL_COUNTRIESFORBRAND = "api/location/GetCountriesForBrand";
	const URL_COUNTIESFORSTATE = "api/location/GetCountiesForState";

	const dom = new FindALocationBlockDom($module);
	const validator = new FindALocationFieldValidator(dom);

	const useExclusiveTerritories = $module.dataset.exclusiveTerritories === "True";
	const displayBrandsOnly = $module.dataset.brandsOnly === "True";

	const marketDropdown = new FindALocationDropDown("#market");
	const brandsDropdown = new FindALocationDropDown("#brands");
	const countryDropdown = new FindALocationDropDown("#country");
	const countyDropdown = new FindALocationDropDown("#county");
	const distanceDropdown = new FindALocationDropDown("#distance");
	const productServicesDropdown = new FindALocationDropDown("#productcategories");
	const servicesDropdown = new FindALocationDropDown("#services");
	const stateDropdown = new FindALocationDropDown("#state");

	const allDropDowns = [
		marketDropdown,
		brandsDropdown,
		countryDropdown,
		countyDropdown,
		distanceDropdown,
		productServicesDropdown,
		servicesDropdown,
		stateDropdown,
	];

	const preFilterLocationType = window.config.locationFilters.preFilterLocationType;

	const facets = new LocationFacets($module, dom.getClearFacetsButton());

	const locationResults = new LocationResults({
		el: dom.getSearchResultsContainer(),
		getDistanceUnit: dom.getDistanceUnit.bind(dom),
	});

	dom.hideEverything();

	if (!displayBrandsOnly) {
		toggleFramedFilters();
	}

	if (useExclusiveTerritories) {
		dom.addNotApplicableToDropdown(brandsDropdown);
	}

	bindEvents();

	function bindEvents() {
		const isLocationTypePreFilterRequired = window.config.locationFilters.preFilterLocationType === "" ? false : true;

		addListener(dom.getClearFacetsButton(), "click", clearFacets);
		addListener(dom.getResetFiltersLink(), "click", resetFilters);
		addListener(dom.getRangeCheckBox(), "click", showHideReset);
		addListener(dom.getQueryField(), "blur", showHideReset);
		addListener(dom.getZipInput(), "beforeinput", function () {
			var timeout = setTimeout(() => {
				showHideReset();
				clearTimeout(timeout);
			}, 100);
		});

		if (dom.getCountryToggle()) {
			addListener(dom.getCountryToggleButton(), "click", (e) => {
				search(e, isLocationTypePreFilterRequired);
			});
		}

		dom.getSearchButtons().forEach(($searchButton) => {
			$searchButton.addEventListener("click", (e) => {
				skipValidation = false;
				search(e, isLocationTypePreFilterRequired);
			});
		});

		brandsDropdown.listenTo("change", toggleFramedFilters);
		stateDropdown.listenTo("change", getCounties);

		allDropDowns.forEach((dropdown) => {
			dropdown.listenTo("change", showHideReset.bind(this));
		});

		dom.getClosePanelTriggerElements().forEach(($element) => {
			$element.addEventListener("click", (event) => {
				event.preventDefault();
				dom.toggleFacetsContainer();
			});
		});
	}

	function addListener(element, action, callback) {
		if (element) {
			element.addEventListener(action, callback);
		}
	}

	function search(e, isLocationTypePreFilterRequired) {
		const valid = skipValidation !== null && skipValidation ? true : validateForm();

		if (e) {
			e.preventDefault();
			if (e.type !== "click" && e.keyCode !== 13 && e.type !== "change") {
				return false;
			}
		}

		if (valid) {
			if (dom.getQueryField().value) {
				dom.setMessageText(dom.getQueryField().value);
			}

			locationResults.search(getSearchParams(isLocationTypePreFilterRequired), renderFacets.bind(this));
		}

		return false;
	}

	function renderFacets(facetGroups) {
		facets.renderFacets(facetGroups, dom.getSearchFacets(), search);
	}

	function clearFacets() {
		facets.clearFacets();
		this.skipValidation = true;
		search();
	}

	function resetFilters() {
		location.reload();
	}

	function getMarkets() {
		if (brandsDropdown.text() !== "Not Applicable" && !brandsDropdown.isOnOption(0)) {
			const encodedBrand = encodeURIComponent(brandName);
			const url = resolveApiUrl(URL_MARKETSFORBRAND, {
				brand: encodedBrand,
				brandId: brandsDropdown.value(),
				blockId: window.config.locationFilters.blockid,
			});

			fetch(url)
				.then((response) => response.json())
				.then((data) => {
					if (hideLocationFiltersForBrandRedirect(data, brandName)) {
						marketDropdown.populate(data.markets, true, false);
					}
				})
				.catch((err) => {
					console.warn(`Error Getting Markets: ${err}`);
				});
		}

		if (countryDropdown.exists()) {
			getCountries();
		}

		if (stateDropdown.exists() && countyDropdown.exists()) {
			getStates();
		}
	}

	function getStates() {
		const url = resolveApiUrl(URL_STATESFORBRAND, {
			brand: encodeURIComponent(brandName),
		});

		fetch(url)
			.then((response) => response.json())
			.then((data) => {
				if (data) {
					stateDropdown.populate(data, true, false);
				}
			})
			.catch((err) => {
				console.warn(`Error getting states: ${err}`);
			});
	}

	function getCountries() {
		const url = resolveApiUrl(URL_COUNTRIESFORBRAND, {
			brand: encodeURIComponent(brandName),
		});

		fetch(url)
			.then((response) => response.json())
			.then((data) => {
				countryDropdown.populate(data, false, true);
			})
			.catch((err) => {
				console.warn(`Error Getting Countries: ${err}`);
			});
	}

	function getCounties() {
		const state = stateDropdown.text();
		const url = resolveApiUrl(URL_COUNTIESFORSTATE, {
			brand: encodeURIComponent(brandName),
			state: state,
		});

		fetch(url)
			.then((response) => response.json())
			.then((data) => {
				if (data.length) {
					countyDropdown.populate(data, true);
					countyDropdown.show();
				} else {
					countyDropdown.hide();
				}
			})
			.catch((err) => {
				console.warn(`Error Getting Counties: ${err}`);
			});
	}

	function validateForm() {
		let validationPassed = true;

		dom.clearValidation();

		if (currentBrandIsNotAFilterBrand()) {
			validationPassed &= validator.validateQueryField();
		} else if (isLeadsFilterSearch() && currentBrandIsAFilterBrand()) {
			validationPassed &= validator.validateMarketDropdown(marketDropdown);
			validationPassed &= validator.validateMarketsAgainstZipStateAndCounty(stateDropdown, countyDropdown);
			validationPassed &= validator.validateCountyAgainstZipAndState(stateDropdown, countyDropdown);
			validationPassed &= validator.validateZipAgainstZipAndState(stateDropdown);
		}

		if (validationPassed) {
			dom.clearValidation();
		}

		return validationPassed;
	}

	function isLeadsFilterSearch() {
		return window.config.locationFilters.mode === "LeadsFilterSearch";
	}

	function toggleFramedFilters() {
		brandName = brandsDropdown.text() ? brandsDropdown.text() : window.config.locationFilters.brand;

		getMarkets();

		dom.hideEverything();

		if (isLeadsFilterSearch()) {
			if (currentBrandIsAFilterBrand()) {
				dom.showExclusiveTerritoriesFilters();

				marketDropdown.reset();

				stateDropdown.reset();

				countyDropdown.populate(null, true);
			} else {
				dom.showRegularFields();
			}
		} else {
			dom.showRegularFields();

			dom.showMessageField();

			if (currentBrandIsAFilterBrand() !== true) {
				dom.showGreyContentArea();
			}
		}

		if (useExclusiveTerritories) {
			dom.addNotApplicableToDropdown(brandsDropdown);
		}
	}

	function currentBrandIsAFilterBrand() {
		const brandIsFiltered =
			window.config.locationFilters.filter(function (el) {
				return el.brandName === brandsDropdown.text();
			}).length > 0;

		return brandIsFiltered;
	}

	function currentBrandIsNotAFilterBrand() {
		return !currentBrandIsAFilterBrand();
	}

	function getSearchParams(isLocationTypePreFilterRequired) {
		const serviceFacets = facets.getFacets("Services");
		const brandFacets = facets.getFacets("Brands");
		const typeFacets = facets.getFacets("Types");
		const country = countryIsLocked() ? window.config.locationFilters.currentCountry : null;
		const market = window.config.locationFilters.preFilterMarket !== "" ? window.config.locationFilters.preFilterMarket : marketDropdown.value();

		const params = {
			keyword: dom.getQueryField().value,
			radius: distanceDropdown.value(),
			radiusunit: dom.getDistanceUnit().value,
			brand: currentBrandIsAFilterBrand() === true ? brandsDropdown.text() : brandsDropdown.value() === "-1" ? "" : brandsDropdown.value(),
			service: servicesDropdown.value(),
			productcategory: productServicesDropdown.value(),
			latitude: "",
			longitude: "",
			isFilteredSearch: currentBrandIsAFilterBrand() === true,
			market: market,
			country: countryDropdown.value(),
			state: stateDropdown.value(),
			county: countyDropdown.value(),
			zip: dom.getZipInput() ? dom.getZipInput().value : "",
			currentpageid: window.config.locationFilters.currentpageid,
			isGlobalLocationPage: window.config.locationFilters.brand === "",
			currentCountry: country,
		};

		if (serviceFacets) {
			params.serviceFacets = serviceFacets;
		}

		if (typeFacets) {
			params.types = typeFacets;
		}

		if (preFilterLocationType && isLocationTypePreFilterRequired) {
			if (!params.types && window.config.locationFilters.preFilterLocationType !== "0") {
				params.types = Array.from(window.config.locationFilters.preFilterLocationType);
			}
		}

		if (brandFacets) {
			params.brandFacets = brandFacets;
		}

		return params;
	}

	function countryIsLocked() {
		if (!dom.getCountryToggle()) {
			return false;
		}

		return dom.getCountryToggleButton().dataset.isOn === "true";
	}

	function hideLocationFiltersForBrandRedirect(data, brand) {
		if (data.IsRedirectionEnabled && !isRedirectionDisableForBrandPage(brand)) {
			dom.setToRedirectMode(data.RedirectionText);

			return false;
		}

		dom.hideElement(dom.getRedirectionTextElement());
		dom.showSearchButton();

		return true;
	}

	function isRedirectionDisableForBrandPage(brand) {
		if (window.config.locationFilters.brand && window.config.locationFilters.brand === brand) {
			return true;
		}
		return false;
	}

	function isAnyDropDownChanged() {
		return (
			allDropDowns.filter((dropdown) => {
				return dropdown.isNotDefaultValue();
			}).length > 0
		);
	}

	function showHideReset() {
		if (dom.getDistanceUnitElement().checked || dom.getQueryField().value || dom.getZipInput().value || isAnyDropDownChanged()) {
			dom.enableSubmitButtons();
			dom.showResetLink();
			return;
		}

		dom.disableSubmitButtons();
		dom.hideResetLink();
	}
}

export default {
	view: "findALocationBlock",
	init,
};
